import { ReactNode, useMemo } from "react";
import { useTransform, motion, MotionValue } from "motion/react";
import random from "lodash/random";
import { useIsDesktop } from "@hooks/useIsDesktop";

export const RandomTwistFrame = ({
  children,
  value,
}: {
  children: ReactNode;
  value: MotionValue<number>; // Must be between -1 & 1
}) => {
  const isDesktop = useIsDesktop();

  const randomValues = useMemo(() => {
    const translateRange = isDesktop ? 100 : 50;

    return {
      rotate: {
        from: random(-15, 15),
        to: random(-15, 15),
      },
      x: {
        from: random(-translateRange, translateRange),
        to: random(-translateRange, translateRange),
      },
      y: {
        from: random(-translateRange, translateRange),
        to: random(-translateRange, translateRange),
      },
    };
  }, [isDesktop]);

  const x = useTransform(
      value,
      [-1, 0, 1],
      [
        randomValues.x.from,
        randomValues.x.to,
        randomValues.x.to + (randomValues.x.to - randomValues.x.from),
      ]
    ),
    y = useTransform(
      value,
      [-1, 0, 1],
      [
        randomValues.y.from,
        randomValues.y.to,
        randomValues.y.to + (randomValues.y.to - randomValues.y.from),
      ]
    ),
    rotate = useTransform(
      value,
      [-1, 0, 1],
      [
        randomValues.rotate.from,
        randomValues.rotate.to,
        randomValues.rotate.to +
          (randomValues.rotate.to - randomValues.rotate.from),
      ]
    );

  return <motion.div style={{ x, y, rotate }}>{children}</motion.div>;
};
